import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M3 1V1.938H2V1H3Z" fill="currentColor" />
    <path d="M6 1V1.938H5V1H6Z" fill="currentColor" />
    <path d="M9 1V1.938H8V1H9Z" fill="currentColor" />
    <path d="M12 1V1.938H11V1H12Z" fill="currentColor" />
    <path d="M15 1V1.938H14V1H15Z" fill="currentColor" />
    <path d="M18 1V1.938H17V1H18Z" fill="currentColor" />
    <path d="M3 19V20H2V19H3Z" fill="currentColor" />
    <path d="M3 17H2V16H3V17Z" fill="currentColor" />
    <path d="M3 14H2V13H3V14Z" fill="currentColor" />
    <path d="M3 11H2V10H3V11Z" fill="currentColor" />
    <path d="M3 8H2V7H3V8Z" fill="currentColor" />
    <path d="M3 5H2V4H3V5Z" fill="currentColor" />
    <path d="M18 17H17V16H18V17Z" fill="currentColor" />
    <path d="M18 14H17V13H18V14Z" fill="currentColor" />
    <path d="M18 11H17V10H18V11Z" fill="currentColor" />
    <path d="M18 8H17V7H18V8Z" fill="currentColor" />
    <path d="M18 5H17V4H18V5Z" fill="currentColor" />
    <path d="M6 19V20H5V19H6Z" fill="currentColor" />
    <path d="M9 19V20H8V19H9Z" fill="currentColor" />
    <path d="M12 19V20H11V19H12Z" fill="currentColor" />
    <path d="M15 19V20H14V19H15Z" fill="currentColor" />
    <path d="M18 19V20H17V19H18Z" fill="currentColor" />
    <path
      d="M13.792 8.608L15 4L10.856 6.35L12.277 6.719L6.93 13.671L6.208 12.392L5 17L9.144 14.65L7.722 14.281L13.07 7.328L13.792 8.608Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Diameter');

export default Icon;
